import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Email is required");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/forgot-password`,
        { email }
      );
      setMessage(response.data.message); // Success message from the backend
      setError(""); // Clear any previous errors
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
      setMessage(""); // Clear success message if error occurs
    }
  };

  return (
    <div className="bg-image d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="card shadow p-4 boxbg" style={{ width: "400px" }}>
        <div className="bg-overlay"></div>
        <div className="cont-int text-white">
          <div className="text-center mb-2">
            <Link className="navbar-brand" to="/home">
              <img width="100" src={logo} alt="Logo" />
            </Link>
          </div>
          <h2>Forgot Password</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Email:</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            {message && <p style={{ color: "green" }}>{message}</p>}
            {error && <p style={{ color: "red" }}>{error}</p>}
            <button type="submit" className="btn btn-primary w-100">
              Send Reset Link
            </button>
          </form>
          <p className="text-center mt-3">
            Don't have an account?{" "}
            <Link to="/register" className="text-decoration-none loglink">
              Register here
            </Link>{" "}
            |{" "}
            <Link to="/login" className="text-decoration-none loglink">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
